import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import MyHeader from 'myComponents/MyHeader/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import {
    ABOVE_THE_HEADER,
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';
import FaqPage from './routes/FaqPage';

class App extends React.Component {

    render() {
        const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            document.body.classList.add('ios-mobile-view-height')
        }
        else if (document.body.classList.contains('ios-mobile-view-height')) {
            document.body.classList.remove('ios-mobile-view-height')
        }
        return (
            <div className={`app-container ${drawerStyle}`}>
                <Sidebar/>

                <div className="app-main-container">
                    <div
                        className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
                        {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
                        <TopNav styleName="app-top-header"/>}
                        <MyHeader/>
                        {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
                        <TopNav/>}
                    </div>

                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                                   <Switch>
                                      <Route path={`${match.url}/faq/:query?`}
                                             component={asyncComponent(() => import('./routes/FaqPage'))}/> 
                                      <Route path={`${match.url}/mydata`}
                                             component={asyncComponent(() => import('./routes/MyDataPage'))}/> 
                                      <Route path={`${match.url}/service/:sid/:command?`}
                                             component={asyncComponent(() => import('./routes/ServiceDetailsPage'))}/> 
                                      <Route path={`${match.url}/iptv/:sid/:command?`}
                                             component={asyncComponent(() => import('./routes/IpTvServicePage'))}/> 
                                      <Route path={`${match.url}/email`}
                                             component={asyncComponent(() => import('./routes/EmailServicePage'))}/> 
                                      <Route path={`${match.url}/impressum`}
                                             component={asyncComponent(() => import('./routes/ImpressumPage'))}/> 
                                      <Route path={`${match.url}/support`}
                                             component={asyncComponent(() => import('./routes/SupportPage'))}/> 
                                      <Route path={`${match.url}/invoices`}
                                             component={asyncComponent(() => import('./routes/InvoicesPage'))}/> 
                                             {/*
                                      <Route path={`${match.url}/faq`}
                                             component={asyncComponent(() => import('./routes/FaqPage'))}/> 
                                      <Route path={`${match.url}/contact-data`}
                                             component={asyncComponent(() => import('./routes/ContactDataPage'))}/> 
                                      <Route path={`${match.url}/invoice-data`}
                                             component={asyncComponent(() => import('./routes/InvoiceDataPage'))}/> 
                                      <Route path={`${match.url}/portal-access`}
                                             component={asyncComponent(() => import('./routes/PortalAccessPage'))}/> 
                                      */}       
                                      <Route path={`${match.url}/verify-email/:eid`}
                                             component={asyncComponent(() => import('./routes/VerifyEmailPage'))}/> 
                                      <Route path={`${match.url}/welcome`}
                                             component={asyncComponent(() => import('./routes/WelcomePage'))}/> 
                                      <Route
                                      component={asyncComponent(() => import('components/Error404'))}/>
                                  </Switch>
                        </div>
                        <Footer/>
                    </main>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({settings,faq}) => {
    const {drawerType, navigationStyle, horizontalNavPosition} = settings;
    return {
           drawerType, 
           navigationStyle, 
           horizontalNavPosition,
           faq
       }
};
export default withRouter(connect(mapStateToProps)(App));